import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const FeatureContext = createContext({ features: null, labels: {}, permissions: [], refresh: () => {} });

export const FeatureProvider = ({ children }) => {
  const { user } = useAuth();
  const [features, setFeatures] = useState(null);
  const [labels, setLabels] = useState({});
  const [permissions, setPermissions] = useState([]);

  const refresh = () => {
    if (user?.role === "employee") {
      setFeatures(null);
      api.get("/employee/me").then((r) => setPermissions(r.data.permissions || [])).catch(() => setPermissions([]));
      return;
    }
    setPermissions([]);
    if (!user || user.role !== "merchant") { setFeatures(null); return; }
    api.get("/features/mine").then((r) => { setFeatures(r.data.features); setLabels(r.data.labels || {}); }).catch(() => setFeatures(null));
  };

  useEffect(refresh, [user?.id, user?.role]); // eslint-disable-line react-hooks/exhaustive-deps

  return <FeatureContext.Provider value={{ features, labels, permissions, refresh }}>{children}</FeatureContext.Provider>;
};

// null features (not loaded / not merchant) ⇒ treated as enabled
export const useFeatures = () => useContext(FeatureContext);
export const useFeatureEnabled = (key) => {
  const { features } = useFeatures();
  return !features || features[key] !== false;
};
